import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  IdentityVerificationReviewsProvider,
} from 'Components/AdvisorApp/Viewport/ApexAdminPortal/IdentityVerificationReviews/IdentityVerificationReviewsContext';
import useUserContext from 'Context/UserContext';
import IdentityVerificationReviewContent
  from 'Components/AdvisorApp/Viewport/ApexAdminPortal/IdentityVerificationReviews/identityVerificationReviewContent';

const styles = () => ({
  root: {},
});

const IdentityVerificationReviews = () => {
  const { agentResource } = useUserContext();
  return (
    <IdentityVerificationReviewsProvider agentResource={agentResource}>
      <IdentityVerificationReviewContent />
    </IdentityVerificationReviewsProvider>
  );
};

IdentityVerificationReviews.defaultProps = {};

IdentityVerificationReviews.propTypes = {};

export default withStyles(styles)(IdentityVerificationReviews);
